import { ChangeEvent, FC, useState } from "react"
import classNames from "classnames"
import { Variant } from "@/types/index"
import "./index.scss"

interface TextAreaProps {
   variant?: Variant
   className?: string
   name?: string
   type?: string
   value: string
   onChange: (e: ChangeEvent<HTMLTextAreaElement>) => void
   placeholder?: string
   error?: boolean
   disabled?: boolean
   rows?: number
   ["data-testid"]?: string
}

const TextArea: FC<TextAreaProps> = ({
   variant = Variant.DEFAULT,
   className,
   name,
   value,
   onChange,
   placeholder,
   error = false,
   disabled = false,
   rows = 3,
   ["data-testid"]: dataTestId,
}) => {
   const [isFocused, setIsFocused] = useState(false)

   return (
      <textarea
         rows={rows}
         draggable="false"
         name={name}
         className={classNames("text-area", {
            [`${className}`]: className,
            "text-area--lg": variant === Variant.LARGE,
            "text-area--focused": isFocused,
            "text-area--error": error,
            "text-area--disabled": disabled,
         })}
         value={value}
         {...(!disabled && { onChange: (e) => onChange(e) })}
         {...(dataTestId && { "data-testid": dataTestId })}
         placeholder={placeholder}
         disabled={disabled}
         onFocus={() => setIsFocused(true)}
         onBlur={() => setIsFocused(false)}
      />
   )
}

export default TextArea
